export default __webpack_public_path__ + "static/mizu-9487e7c327b4c629088a76d5fd2aa36c.jpg";